export const SET_SOURCE_ACCOUNT = 'SET_SOURCE_ACCOUNT';

export const setSourceAccount = account => ({
  type: SET_SOURCE_ACCOUNT,
  payload: account,
});
